import * as Utils from "../ts/rlAdmin.utils";
import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import { AclService } from "../services/acl-service";
import { EntityService } from "../services/entity-service";

RLShowPanel.$inject = ["$document", "$compile"];
export function RLShowPanel($document: ng.IDocumentService, $compile: ng.ICompileService) {
	var directive: ng.IDirective = {
		restrict: "AE",
		controller: RLShowPanelController,
		controllerAs: "spVM",
		bindToController: true,
		transclude: true,
		template: "<div ng-if=\"spVM.canRead && spVM.isConfigured\"><div ng-transclude></div></div>",
		scope: {
			parentCharTypeID: "=parentCharTypeId",
			parentTemplateID: "=parentTemplateId",
			childCharTypeID: "=childCharTypeId",
			aclString: "@"
		},
		link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLShowPanelController) => {
			controller.panelElement = element;
		}
	};

	return directive;
}

class RLShowPanelController {
	static $inject = ["$scope", "$q", "aclService", "entityService"];

	parentCharTypeID: number;
	parentTemplateID: number;
	childCharTypeID: number;
	aclString: string;
	canRead: boolean;
	isConfigured: boolean;
	panelElement: ng.IAugmentedJQuery;

	constructor(private $scope: ng.IScope,
		private $q: ng.IQService,
		private aclService: AclService,
		private entityService: EntityService) {

	}

	$onInit() {
		this.$scope.$watch(() => [this.parentCharTypeID, this.parentTemplateID, this.childCharTypeID], (newValue, oldValue) => {
			if (newValue[0] != undefined && newValue[1] != undefined && newValue[2] != undefined) {
				this.Init();
			}
		}, true)
	}

	Init() {
		this.canRead = Utils.AclUtil.hasReadAccess(this.aclService.acls, this.aclString);
		var isConfiguredPromise = this.IsConfigured();
	}

	IsConfigured(): ng.IPromise<any> {
		var validChildTemplates: Models.ICharacteristicTemplate[] = [];
		var validParentTemplates: Models.ICharacteristicTemplate[] = [];

		var hasParameters = _.all([this.parentCharTypeID, this.parentTemplateID, this.childCharTypeID], (v) => v != null);

		this.isConfigured = !hasParameters;

		if (!hasParameters) {
			return this.$q.when();
		}

		var childTemplatesPromise = this.entityService.getAssociatedTemplatesForTemplate(this.parentCharTypeID, this.parentTemplateID, this.childCharTypeID)
			.then((childResults) => {
				validChildTemplates = childResults;
			});

		var parentTemplatesPromise = this.entityService.getAssociatedParentTemplatesForTemplate(this.parentCharTypeID, this.parentTemplateID, this.childCharTypeID)
			.then((parentResults) => {
				validParentTemplates = parentResults;
			});

		return this.$q.all([childTemplatesPromise, parentTemplatesPromise])
			.then(() => {
				if (validChildTemplates.length > 0 || validParentTemplates.length > 0) {
					//Check to see if this is a Usage in the Deal Catalog template group
					if (this.childCharTypeID == Consts.CharTypeIDs.usage) {
						var allDealCatalogTemplates: boolean = true;

						for (var i = 0; i < validChildTemplates.length; i++) {
							if (validChildTemplates[i].templateGroupID != 2) {
								allDealCatalogTemplates = false;
								break;
							}
						}

						if (allDealCatalogTemplates) {
							//If all the Usage templates are in the Deal Catalog template group, then we want to override Configuration
							//and set the value to false so that the panel does not display.
							this.isConfigured = false;
						}
						else {
							this.isConfigured = true;
						}
					}
					else {
						this.isConfigured = true;
					}
				}
			});
	}
}
